import {IconProp} from "@fortawesome/fontawesome-svg-core"
import {LocationState} from "history"
import {useAuctionSettings} from "hooks/StateHooks"

export type AppMenuItem = {
  filter?: string
  hideModal?: () => void
  history?: LocationState
  visible: boolean
  path?: string
  title?: string
  icon?: IconProp
}

export const AppMenu = () => {
  const settings = useAuctionSettings()
  const internalHandler = !!(window as any)?.app?.user?.authority?.mod_speed_auction_claim;

  return <Array<AppMenuItem>>[
    {
      filter: null,
      icon: 'gavel',
      title: 'Alle Auktionen',
      visible: !internalHandler,
      totalCount: true
    },
    {
      filter: 'hot-bid',
      icon: 'fire',
      title: 'Hot Bid',
      visible: !internalHandler && settings && settings.auctionTypes ? settings.auctionTypes.auction : false,
      totalCount: true
    },
    {
      filter: 'no-bids-yet',
      icon: 'not-equal',
      title: 'Ohne Gebote',
      visible: !internalHandler,
      totalCount: true
    },
    {
      filter: 'ending-today',
      icon: 'clock',
      title: 'Endet Heute',
      visible: !internalHandler,
      totalCount: true
    },
    {
      filter: 'immediate',
      icon: 'bolt',
      title: 'Sofort Kauf',
      visible: !internalHandler,
      totalCount: true
    },
    {
      filter: 'newly-arrived',
      icon: 'plus',
      title: 'Neueste',
      visible: !internalHandler,
      totalCount: true
    },
    {
      title: 'Meine Ansichten',
      visible: !internalHandler
    },
    {
      path: '/dashboard',
      icon: 'tachometer-alt',
      title: 'Dashboard',
      visible: true
    },
    {
      path: '/speed-auktion',
      icon: 'bolt',
      title: 'Speed-Auktion',
      visible: window.app?.user?.authority?.mod_speed_auction_claim || false
    },
    {
      path: '/claimed-vehicles',
      icon: 'shopping-cart',
      title: 'Gekauft',
      visible: internalHandler
    },
    {
      filter: 'my-bids',
      icon: 'car',
      title: 'Gebote',
      visible: !internalHandler
    },
    {
      filter: 'auctioned',
      icon: 'trophy',
      title: 'Ersteigerungen',
      visible: !internalHandler
    },
    {
      filter: 'watched',
      icon: 'star',
      title: 'Beobachtungen',
      visible: !internalHandler
    },
    {
      filter: 'ignored',
      icon: 'eye-slash',
      title: 'Ignoriert',
      visible: !internalHandler
    },
  ]
}
